import DesignTokens from '@tableau/design-tokens';
import { TabStyles } from '@tableau/widgets';
import React from 'react';

import { CommonStyles } from '~commonInfra/styles/CommonStyles';
import { telemetryConsumerWrapper } from '~commonInfra/telemetryEvents/contexts/TelemetryConsumerWrapper';
import { ContentClickedTelemetryContext } from '~commonInfra/telemetryEvents/contexts/TelemetryContexts';
import { ContentClickedEventHandler } from '~commonInfra/telemetryEvents/types/ContentTelemetryTypes';
import { mouseUpFactory } from '~commonInfra/telemetryEvents/util/EventHandlerFactories';
import { applyColor }from '~src/style/ColorService';

import { CardViewStyles } from './CardViewStyles';

const baseLinkStyle: React.CSSProperties = {
  fontWeight: 'bold',
  color: applyColor(DesignTokens.color.link.inline.default.active, CommonStyles.Colors.HyperlinkBlue),
  position: 'relative',
  zIndex: 1 // to ensure it appears above the card's <a> tag
};

const recommendationLinkStyle: React.CSSProperties = {
  color: applyColor(DesignTokens.color.font.default.secondary, TabStyles.Colors.F8),
  fontWeight: 'normal',
  position: 'relative'
};

const inactiveLinkStyle: React.CSSProperties = {
  fontWeight: 'bold',
  color: applyColor(DesignTokens.color.font.default.secondary, TabStyles.Typography.Color.PrimaryMedium),
};

export interface CardTextAndLinkProps {
  text: string;
  url: string;
  urlDisplayName: string;
  isRecommendationType?: boolean;
  /** The overriding style of the div container */
  style?: React.CSSProperties;
}

export class CardTextAndLink extends React.PureComponent<CardTextAndLinkProps> {

  public render(): JSX.Element {
    const linkStyle: React.CSSProperties = this.props.isRecommendationType ? recommendationLinkStyle : baseLinkStyle;

    const workbookTitleLink = telemetryConsumerWrapper(ContentClickedTelemetryContext.Consumer, (sendOpenContentTelemetry: ContentClickedEventHandler) =>
      <a style={linkStyle} href={this.props.url} onClick={this.onLinkClick} onMouseUp={mouseUpFactory<HTMLAnchorElement>(sendOpenContentTelemetry)}>
        {this.props.urlDisplayName}
      </a>
    );

    return (
      <div style={this.props.style} className={CardViewStyles.CardTextAndLink} title={this.props.text + ' ' + this.props.urlDisplayName}>
        {this.props.text + ' '}
        {this.props.url && workbookTitleLink}
        {!this.props.url &&
          <span style={inactiveLinkStyle}>{this.props.urlDisplayName}</span>
        }
      </div>
    );
  }

  private onLinkClick = (e: React.MouseEvent<HTMLAnchorElement>): boolean => {
    e.stopPropagation();
    return false;
  };
}
